import type { PluralForms } from '@/shared/lib/plural';

export const VISITORS: PluralForms = ['посетитель', 'посетителя', 'посетителей'];
export const EMAILS: PluralForms = ['письмо', 'письма', 'писем'];

/** Провайдеры входа (9.15) — для людей. */
export const PROVIDER_NAME: Record<string, string> = {
  google: 'Google',
  vk: 'VK ID',
  yandex: 'Яндекс ID',
};
